<template>
    <div>
        <footer class="parallax dbcolor">
            <div class="container">
                <div class="row" v-for="(config, index) in configs" :key="index">
                    <div class="col-lg-4 col-md-4 col-xs-12">
                        <div class="widget clearfix">
                            <div class="logo">
                                <img src="@/assets/images/logo.png" alt="" width="100px"/>
                            </div>
                            <div class="footer-right">
                                <ul class="footer-links-soi">
                                    <li v-if="config.facebook"><a :href="config.facebook" target="_blank"><i class="fa fa-facebook"></i></a></li>
                                    <li v-if="config.instagram"><a :href="config.instagram" target="_blank"><i class="fa fa-instagram"></i></a></li>
                                    <li v-if="config.twitter"><a :href="config.twitter" target="_blank"><i class="fa fa-twitter"></i></a></li>
                                    <li v-if="config.youtube"><a :href="config.youtube" target="_blank"><i class="fa fa-youtube"></i></a></li>
                                </ul><!-- end links -->
                            </div>						
                        </div><!-- end clearfix -->
                    </div><!-- end col -->

                    <div class="col-lg-4 col-md-4 col-xs-12">
                        <div class="widget clearfix">
                            <div class="widget-title">
                                <h3>Links Úteis</h3>
                            </div>
                            <ul class="footer-links">
                                <li><router-link :to="{name: 'posgraduacao'}">Pós Graduação</router-link></li>
                                <li><router-link :to="{name: 'politicadeprivacidade'}">Política de Privacidade</router-link></li>
                                <li><router-link :to="{name: 'centralderelacionamento'}">Central de Relacionamento</router-link></li>
                                <li><router-link :to="{name: 'contato'}">Contato</router-link></li>
                            </ul><!-- end links -->
                        </div><!-- end clearfix -->
                    </div><!-- end col -->
                    
                    <div class="col-lg-4 col-md-4 col-xs-12">
                        <div class="widget clearfix">
                            <div class="widget-title">
                                <h3>Contatos</h3>
                            </div>

                            <ul class="footer-links">
                                <li>{{ config.email }}</li>
                                <li>{{ config.cnpj }}</li>
                                <li>{{ config.endereco }}</li>
                                <li>{{ config.celular }}</li>
                            </ul><!-- end links -->
                        </div><!-- end clearfix -->
                    </div><!-- end col -->
                    <a v-if="config.celular" :href="'https://api.whatsapp.com/send?phone='+config.celular" target="_blank">
                        <img class="whatsapp" src="https://images.tcdn.com.br/static_inst/integracao/imagens/whatsapp.png">
                    </a>
                </div><!-- end row -->
            </div><!-- end container -->
        </footer><!-- end footer -->

        <div class="copyrights">
            <div class="container">
                <div class="footer-distributed">
                    <div class="footer-center">                   
                        <p class="footer-company-name">Todos os direitos reservados. &copy; 2021</p>
                    </div>
                </div>
            </div><!-- end container -->
        </div><!-- end copyrights -->

    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    mounted() {
        this.getConfigs()
            .catch(response => this.$vToastify.error('Falha ao carregar configurações', 'Erro'))
    },

    computed: {
        ...mapState({
            configs: state => state.configs.items
        })
    },

    methods: {
        ...mapActions([
            'getConfigs',
        ])
    },
}
</script>